import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCards = ({ stats }) => {
  const cards = [
    {
      label: 'Total Projects',
      value: stats?.total,
      icon: 'Image',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Featured',
      value: stats?.featured,
      icon: 'Star',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Floor Types',
      value: stats?.floorTypes,
      icon: 'Grid3x3',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Rooms',
      value: stats?.rooms,
      icon: 'Home',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
              <Icon name={card?.icon} size={20} className={card?.color} />
            </div>
            <span className="text-2xl font-bold text-text-primary">{card?.value}</span>
          </div>
          <p className="text-sm text-text-secondary">{card?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;